import "core-js/modules/es.array.push.js";
import HeaderContainer from '@/components/HeaderContainer/HeaderContainer.vue';
import LoginPage from '@/components/LoginPage/LoginPage.vue';
import { ref } from 'vue';
import bus from './lib/bus';
import { init, getUserInfo, getRules } from './api/api';
import { useRouter } from 'vue-router';
import { useInfoStore, useRuleStore } from './store';
import { storeToRefs } from 'pinia';
import { showToast } from 'vant';
import { onMounted } from 'vue';
import Loading from './components/LoadingPage/LoadingPage.vue';
export default {
  name: 'App',
  components: {
    HeaderContainer,
    LoginPage,
    Loading
  },
  setup() {
    const payKeep = ref(['GiftView', 'ShopView']);
    const router = useRouter();
    const store = useInfoStore();
    const rules = useRuleStore();
    const loading = ref(false);
    bus.$on('payKeep', e => {
      payKeep.value = e;
    });
    // 登录弹窗
    const show = ref(false);
    const showLogins = () => {
      show.value = true;
    };
    // 联系客服
    bus.$on('showKf', () => {
      show.value = true;
      setTimeout(() => {
        bus.$emit('showKfSec');
      }, 0);
    });
    const closeLoginContainer = () => {
      show.value = false;
    };
    const listenClose = () => {
      bus.$emit('scrollGoToTop');
    };
    // 登录成功
    const token = ref('');
    bus.$on('sendToken', e => {
      token.value = e;
      show.value = false;
    });
    // 调取登录弹窗
    bus.$on('click', () => {
      showLogins();
    });
    bus.$on('toLogin', () => {
      router.push('/login');
    });
    bus.$on('login', noJump => {
      bus.$emit('payKeep', ['GiftView', 'ShopView']);
      loading.value = true;
      init().then(res => {
        if (res.code !== 200) return showToast(res.message);
        getUserInfo().then(res => {
          localStorage.setItem('userInfo', JSON.stringify(res.data));
          localStorage.removeItem('selectRole');
          store.$patch({
            userInfo: res.data
          });
          !noJump && router.push('/');
        });
      }).catch(() => {
        showToast('登录失败，请稍后再试');
      }).finally(() => {
        loading.value = false;
      });
    });
    // 监听是否进充值页
    const isPay = ref(false);
    bus.$on('showPayHeader', () => {
      isPay.value = true;
    });
    bus.$on('closePayHeader', () => {
      isPay.value = false;
    });
    bus.$on('changeLoading', status => {
      loading.value = status;
    });
    onMounted(() => {
      if (localStorage.getItem('token')) {
        getUserInfo().then(res => {
          localStorage.setItem('userInfo', JSON.stringify(res.data));
          store.$patch({
            userInfo: res.data
          });
        }).catch(() => {
          showToast('获取信息失败，请稍后再试');
        });
      }
      getRules({
        lang: 'zh-cn'
      }).then(res => {
        rules.$patch({
          rules: res.data
        });
      });
    });
    return {
      listenClose,
      isPay,
      token,
      show,
      showLogins,
      closeLoginContainer,
      payKeep,
      loading,
      ...storeToRefs(store)
    };
  }
};